import defaultColor from "@/components/color";
export default {
    cptDataForm:{
        dataSource: 1, pollTime: 0, dataText: '{"value":90}',
    },
    attribute:{
        title:'速度',titleSize:18,titleColor:'#fff',numColor:'#D0E7FF',numSize:30,titleOffsetTop:90, format:'{value}%',
        progressColor:'#35D0E6',progressBg:'#00000000',roseType:'false',borderRadius:20,progressWidth:70,borderColor:'#00000000',
        innerRingShow:false,
        alarmConfig:{color:'#FF0000',operator:'>',threshold:null},
        cptTableData: [{ "name": "指标", "value": "", "namekey": "value" }]
    },
}